import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { use } from 'react';

const UserForm = () => {
  const [realname, setRealname] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');
  const [company, setCompany] = useState('');
  const [eposta, setEposta] = useState('');
  const [dogumt, setDogumt] = useState('');
  const [girist, setGirist] = useState('');
  const [egitimd, setEgitimd]=useState('');
  const [annead, setAnnead]=useState('');
  const [babaad, setBabaad]=useState('');
  const [cinsiyet, setCinsiyet]=useState('');
  const [medenih, setMedenih]=useState('');
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCity2, setSelectedCity2] = useState("");
  const [adres, setAdres] = useState("");
  const [ehliyet, setEhliyet]= useState("");
  const [userTCKN, setUserTCKN]=useState("");
  const [fotoFile, setFotoFile] = useState(null);
  const [base64Foto, setBase64Foto] = useState(null);
  const [excelFile, setExcelFile] = useState(null);

  const [showPassword, setShowPassword] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const navigate = useNavigate();


  const handleLogout = () => {
      localStorage.removeItem('username');
      navigate('/');
  };
  const cities = [
    "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya",
    "Ankara", "Antalya", "Ardahan", "Artvin", "Aydın", "Balıkesir",
    "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis",
    "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum",
    "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan",
    "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkari",
    "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
    "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale",
    "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya",
    "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir",
    "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
    "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon",
    "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"
  ];


  const [isTCKNValid, setIsTCKNValid] = useState(true);

  // TCKN doğrulama fonksiyonu
  const isValidTCKN = (tckn) => {
    // TCKN 11 haneli olmalı
    if (tckn.length !== 11) return false;

    // TCKN'nin ilk haneleri 0 olmamalı
    if (tckn[0] === "0") return false;

    // TCKN'nin sadece rakamlardan oluşması gerekir
    if (!/^\d+$/.test(tckn)) return false;

    // TCKN'nin son 10 hanesinin doğruluğu kontrol edilir
    const digits = tckn.split('').map(Number);

    // 10. hane algoritması
    const sumFirst10 = digits.slice(0, 10).reduce((acc, curr, idx) => {
      return acc + curr * (idx % 2 === 0 ? 7 : 1);
    }, 0);
    if (sumFirst10 % 10 !== digits[9]) return false;

    // 11. hane algoritması
    const sumFirst9 = digits.slice(0, 9).reduce((acc, curr) => acc + curr, 0);
    if (sumFirst9 % 10 !== digits[10]) return false;

    return true;
  };

  // TCKN input değiştiğinde kontrol etme
  const handleTCKNChange = (e) => {
    const value = e.target.value;
    setUserTCKN(value);

    // TCKN geçerliliğini anında kontrol et
    if (value && !isValidTCKN(value)) {
      setIsTCKNValid(false); // Geçersiz TCKN
    } else {
      setIsTCKNValid(true); // Geçerli TCKN
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = {
      realname,
      username,
      password,
      phone,
      company,
      status,
      eposta,
      dogumt,
      girist,
      egitimd,
      annead,
      babaad,
      cinsiyet,
      selectedCity,
      selectedCity2,
      adres,
      ehliyet,
      userTCKN,
      medenih,
      photo: base64Foto,// Fotoğraf verisini base64 formatında ekliyoruz
    };

    try {
      const response = await fetch('https://api.idekod.com.tr/api/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      if (response.ok) {
        toast.success('Kullanıcı başarıyla eklendi!', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: { 
            backgroundColor: '#4caf50', 
            color: 'white', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            minWidth: '300px' 
          },
          closeButton: <div style={{ color: 'white', marginRight: '8px' }}>✖</div>
        });
        
        // Formu temizle
        setRealname('');
        setUsername('');
        setPassword('');
        setPhone('');
        setCompany('');
        setStatus('');
        setEposta('');
        setDogumt('');
        setGirist('');
        setEgitimd('');
        setAnnead('');
        setBabaad('');
        setCinsiyet('');
        setSelectedCity('');
        setSelectedCity2('');
        setAdres('');
        setEhliyet('');
        setUserTCKN('');
        setMedenih('');
        setBase64Foto(null);  // Fotoğrafı sıfırla

      } else {
        toast.error('Kullanıcı ekleme başarısız oldu.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: { 
            backgroundColor: '#ff4d4d', 
            color: 'white', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            minWidth: '300px' 
          },
          closeButton: <div style={{ color: 'white', marginRight: '8px' }}>✖</div>
        });
      }
    } catch (error) {
      console.error('Hata:', error);
      toast.error('Bir hata oluştu. Lütfen tekrar deneyin.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: { 
          backgroundColor: '#ff4d4d', 
          color: 'white', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          minWidth: '300px' 
        },
        closeButton: <div style={{ color: 'white', marginRight: '8px' }}>✖</div>
      });
    }
  };


  const handleFileChange = (e) => {
    setExcelFile(e.target.files[0]);
    const file = e.target.files[0];
    
    if (file) {
      const reader = new FileReader();
      
      reader.onloadend = () => {
        // Dosya yüklendikten sonra base64 formatında veriyi alıyoruz
        setBase64Foto(reader.result);  // Base64 verisini kaydediyoruz
        setFotoFile(URL.createObjectURL(file)); // Fotoğrafı önizleme için
      };
      
      reader.readAsDataURL(file);  // Base64 formatında okuyoruz
    }
  };


  const handleExcelSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('file', excelFile);

    try {
      const response = await fetch('https://api.idekod.com.tr/api/users/excel', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        alert('Kullanıcılar başarıyla eklendi!');
      } else {
        alert('Excel dosyasından kullanıcı ekleme başarısız oldu.');
      }
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  return (
    <div className="p-6 space-y-8">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
  
  <div className="bg-gray-600 p-4 text-white">
    
<h1 className="text-xl font-semibold text-center">Kullanıcı Ekle</h1>

  </div>
      <form onSubmit={handleSubmit} className="min-w-full table-auto mb-2 py-2 px-4"> 
      <div>
      {fotoFile && <img src={fotoFile} alt="Seçilen Fotoğraf" className="border h-24 w-auto" />}
      
      <div className="mt-4">
        <label className="py-2 px-4 text-left">Fotoğraf Yükle</label>
        <input
          type="file"
          onChange={handleFileChange}
          className="focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
      <div className="mt-3">
            <label className="py-2 px-4  text-left">T.C. Kimlik Numarası:</label>
            <input
              type="text"
              value={userTCKN} 
              onChange={(e) => setUserTCKN(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
       
          <div className="mt-4" >
            <label className="py-2 px-4  text-left">Kullanıcı Ad Soyad:</label>
            <input
              type="text"
              value={realname}
              onChange={(e) => setRealname(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
            <label className="py-2 px-4  text-left">Kullanıcı ID:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
      <label className="py-2 px-4  text-left">
        Şifre:
      </label>
      <div className="relative">
        <input 
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
          placeholder="Şifrenizi giriniz"
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
        >
          {showPassword ? (
             <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-500"
                viewBox="0 0 20 20"
                fill="currentColor"
                >
                <path d="M13.828 10l4.39-4.39a1 1 0 00-1.415-1.415L12.414 8.586 8 4.172a1 1 0 10-1.415 1.415l4.39 4.39-4.39 4.39a1 1 0 101.415 1.415l4.414-4.414 4.39 4.39a1 1 0 001.415-1.415L13.828 10z" />
             </svg>
       
          ) : (
            <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10 3c-4.5 0-8 3.58-8 5s3.5 5 8 5 8-3.58 8-5-3.5-5-8-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
            <circle cx="10" cy="10" r="2" />
          </svg>
      
          )}
        </span>
      </div>
    </div>

          <div>
            <label className="py-2 px-4 text-left">Telefon:</label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>

          <div className="mt-3">
            <label className="py-2 px-4  text-left" >Cinsiyet:</label>
            <select value={cinsiyet} onChange={(e) => setCinsiyet(e.target.value)} required 
             className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full bg-white">
              <option value="">Seçiniz</option>
              <option value="Kadın">Kadın</option>
              <option value="Erkek">Erkek</option>
              <option value="Diğer">Diğer</option>
            </select>
          </div>
          <div className="mt-4">
            <label className="py-2 px-4  text-left" >Medeni Hal:</label>
            <select value={medenih} onChange={(e) => setMedenih(e.target.value)} required 
             className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full bg-white">
              <option value="">Seçiniz</option>
              <option value="Evli">Evli</option>
              <option value="Bekar">Bekar</option>
            </select>
          </div>
          <div className="mt-4">
            <label className="py-2 px-4  text-left" >Eğitim Durumu:</label>
            <select value={egitimd} onChange={(e) => setEgitimd(e.target.value)} required 
           className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full bg-white">
              <option value="">Seçiniz</option>
              <option value="Lisans">Lisans</option>
              <option value="ÖnLisans">Ön Lisans</option>
              <option value="Lise">Lise</option>
              <option value="OrtaOkul">Orta Okul</option>
            </select>
          </div>
          <div className="mt-4">
            <label className="py-2 px-4  text-left" >Ehliyet:</label>
            <select value={ehliyet} onChange={(e) => setEhliyet(e.target.value)} required 
           className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full bg-white">
              <option value="">Seçiniz</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
            </select>
          </div>

          <div className="mt-4">
            <label className="py-2 px-4  text-left">
              Şehir:
            </label>
            <select
              id="city"
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full bg-white"
            >
              <option value="">Şehir seçiniz...</option>
              {cities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>
          <div className="mt-4">
            <label className="py-2 px-4  text-left">
              Doğum Yeri:
            </label>
            <select
              id="city"
              value={selectedCity2}
              onChange={(e) => setSelectedCity2(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full bg-white"
            >
              <option value="">Şehir seçiniz...</option>
              {cities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>

          <div className="mt-4">
            <label className="py-2 px-4  text-left">Anne Ad Soyad:</label>
            <input
              type="text"
              value={annead}
              onChange={(e) => setAnnead(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
            <label className="py-2 px-4  text-left">Baba Ad Soyad:</label>
            <input
              type="text"
              value={babaad}
              onChange={(e) => setBabaad(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          
          <div className="mt-2">
            <label className="py-2 px-4  text-left">Durum: " 0 - Pasif / 1 - Aktif / 3 - Bekleyen "</label>
            <input
              type="text"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
            <label className="py-2 px-4  text-left">Şirket Kısa Kod:</label>
            <input
              type="text"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
            <label className="py-2 px-4  text-left">E-posta:</label>
            <input
              type="email"
              value={eposta}
              onChange={(e) => setEposta(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
            <label className="py-2 px-4  text-left">Doğum Tarihi:</label>
            <input
              type="date"
              value={dogumt}
              onChange={(e) => setDogumt(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>
          <div className="mt-2">
            <label className="py-2 px-4  text-left">İşe Başlangıç Tarihi:</label>
            <input
              type="date"
              value={girist}
              onChange={(e) => setGirist(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>

          <div className="mt-2">
            <label className="py-2 px-4  text-left">Adres:</label>
            <input
              type="text"
              value={adres}
              onChange={(e) => setAdres(e.target.value)}
              required
              className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
            />
          </div>

      
        <button
          type="submit"
          className="w-full bg-customControl text-white font-semibold py-2 rounded-lg hover:bg-customColor2 transition duration-200"
        >
          Kaydet
        </button>
      </form>
      <h2 className="text-xl font-semibold text-center">Excelden Aktar</h2>
        <form onSubmit={handleExcelSubmit} className="min-w-full table-auto mb-2 py-2 px-4">
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            required
            className="focus:outline-none focus:ring-2 focus:ring-blue-500 py-2 px-4 border rounded-md w-full"
          />
          <button
            type="submit"
            className="w-full bg-customControl text-white font-semibold py-2 rounded-lg hover:bg-customColor2 transition duration-200"
          >
            Excelden Aktar
          </button>
          <a
            href="http://pdks.idekod.com.tr/indirmeler/kullanici.xlsx"
            className="w-full bg-customControl text-white font-semibold py-2 rounded-lg hover:bg-customColor2 transition duration-200"
          >
            Örnek Excel Dosyasını İndir
          </a>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
